import { 후기_리치서치_컨텐츠들, 후기_리치서치_컨텐츠_개수들 } from "./review";
import { CREMATORIUM_FAQ_DATA, toFaqPageMainEntity } from "./faqData";

type CrematoriumInput = {
  id: number;
  companyname: string;
  address: string;
  latitude?: number | string | null;
  longitude?: number | string | null;
  telephone?: string | null;
  images?: Array<{ url: string }> | null;
};

export function buildCrematoriumLocalBusinessSchema(
  c: CrematoriumInput,
  options?: { detailUrl?: string }
) {
  const displayName =
    c.companyname.includes("화장장") || c.companyname.includes("화장터")
      ? c.companyname
      : `${c.companyname} 화장장`;

  const schema: Record<string, any> = {
    "@type": "LocalBusiness",
    name: displayName,
    address: {
      "@type": "PostalAddress",
      streetAddress: c.address,
      addressCountry: "KR",
    },
  };

  if (c.latitude && c.longitude) {
    schema.geo = {
      "@type": "GeoCoordinates",
      latitude: Number(c.latitude),
      longitude: Number(c.longitude),
    };
  }
  if (c.telephone) schema.telephone = c.telephone;
  if (c.images?.[0]?.url) schema.image = c.images[0].url;
  if (options?.detailUrl) schema.url = options.detailUrl;

  return schema;
}

export function buildCrematoriumItemListSchema(
  crematoriums: CrematoriumInput[],
  options: { regionText: string; goiWebUrl: string }
) {
  if (!crematoriums || crematoriums.length === 0) return null;

  return {
    "@type": "ItemList",
    name: `${options.regionText} 화장장 추천`,
    numberOfItems: crematoriums.length,
    itemListElement: crematoriums.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: buildCrematoriumLocalBusinessSchema(c, {
        detailUrl: `${options.goiWebUrl}/crematorium-recommendation/${c.id}/`,
      }),
    })),
  };
}

// FAQ 데이터는 faqData.ts에서 단일 소스 관리 (UI 컴포넌트 CrematoriumRegionFAQ와 공유)

export function buildCrematoriumPageSchema(
  crematoriums: CrematoriumInput[],
  options: {
    regionText: string;
    goiWebUrl: string;
    ratingValue?: string;
  }
) {
  const graph: any[] = [];

  const itemList = buildCrematoriumItemListSchema(crematoriums, {
    regionText: options.regionText,
    goiWebUrl: options.goiWebUrl,
  });
  if (itemList) graph.push(itemList);

  graph.push({
    "@type": "Product",
    name: `${options.regionText} 화장장 안내`,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: options.ratingValue ?? "4.97",
      bestRating: "5",
      ratingCount: 후기_리치서치_컨텐츠_개수들.전체,
      reviewCount: 후기_리치서치_컨텐츠_개수들.전체,
    },
    review: 후기_리치서치_컨텐츠들.전체.map((reviewBody, index) => ({
      "@type": "Review",
      reviewBody,
      author: {
        "@type": "Person",
        name: `상주${index}`,
      },
    })),
  });

  graph.push({
    "@type": "FAQPage",
    mainEntity: toFaqPageMainEntity(CREMATORIUM_FAQ_DATA),
  });

  return {
    "@context": "https://schema.org",
    "@graph": graph,
  };
}
